<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入专业名称" v-model="specialty_name" @keyup.enter.native="searchName()"
        class="input-with-select">
        <el-button slot="append" @click="searchName()">
          <img src="@/assets/img/home/search.png" alt="" />
        </el-button>
      </el-input>
    </div>

    <div class="like" v-if="testtt">
      意向专业：<div v-for="(value, i) in testtt" class="specialty-item-like border-1" :key="i" @click="search(value)">
        <div class="specialty-info">
          {{ value }} <span class="color-1">AI分析</span>
        </div>
      </div>
      <hr>
    </div>


    <div class="refulsh" @click="getRefulsh">
      <div>
        推荐专业
      </div>
      <div class="huanyipi">
        换一批 <i class="iconfont luming-pc-shuaxin" style="font-size: 22px; margin-right: 15px; "></i>
      </div>
    </div>


    <div>
      <div class="specialty-item border-1" @click="search(item.specialty_name)" v-for="(item, key) in SpecialtyList"
        :key="key">
        <div class="specialty-info">
          {{ item.specialty_name }} <span class="color-1">AI分析</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: '',
  data() {
    return {
      SpecialtyList: [],
      specialty_name: null,
      page: {
        pageNum: 1,
        pageSize: 33,
      },
      loading: false
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    testtt() {
      if (this.userInfo.like_sp == null || this.userInfo.like_sp == '') return null
      return this.userInfo.like_sp.split('、')
    }
  },
  created() {
    this.getSpecialty()
  },
  methods: {
    searchName() {
      this.pageNum = 1
      this.getSpecialty()
    },
    getSpecialty() {
      if (!this.loading) {
        this.loading = true
        let data = {
          specialty_name: this.specialty_name,
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
          is_wenli: this.userInfo.is_wenli,
          score: this.userInfo.score,
        }

        this.$fecth.post('chat/chats/get_specialty_list', data).then((res) => {
          this.loading = false
          this.SpecialtyList = res.lists
        })
      }

    },

    getRefulsh() {
      this.page.pageNum++
      if (this.page.pageNum > 7) this.page.pageNum = 1
      this.getSpecialty()
    },
    search(e) {
      let data = {
        title: e + '请结合我的信息综合分析一下这个专业的填报策略',
        specialty_name: e,
        type: 3
      }
      this.$emit('getChat', data)
    }
  },
};
</script>

<style scoped lang='less'>
.refulsh {
  color: #008BFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .huanyipi {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}


.search {
  margin-bottom: 20px
}

.specialty-item-like {
  padding: 15px 15px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  display: inline-block;
  margin-right: 20px;
}




.specialty-item {
  padding: 15px 15px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  display: inline-block;
  margin-right: 20px;
}

.specialty-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
</style>
